import { unsafeCoerce } from 'fp-ts/lib/function';
import { PreloadSlot } from '../../UnicronApp/preloader/PreloadSlot';
import { UnknownRecord } from '../types/UnknownRecord';
import { SsrData } from './SsrData';

export class CacheService {
  constructor(private ssrData: SsrData) {}

  private storage: UnknownRecord = this.ssrData.slot('PRELOAD_CACHE', () => ({}));
  public set = <T>(slot: PreloadSlot<T>, value: T) => (this.storage[slot.name] = value);
  public get = <T>(slot: PreloadSlot<T>): T | undefined => unsafeCoerce(this.storage[slot.name]);
}
